import api from "./api";
import { Controllers } from "../types/api.types";
export interface CacheResponse {
  status: string;
  message: string;
  data?: any;
}

const cacheApi = {
  getAllCacheNames: async (): Promise<CacheResponse> => {
    try {
      const response = await api.get(`${Controllers.CACHE}/names`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  clearCacheByName: async (cacheName: string): Promise<CacheResponse> => {
    try {
      const response = await api.post(`${Controllers.CACHE}/clear`, { cacheName });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  clearCacheByNameAndKey: async (cacheName: string, key: string): Promise<CacheResponse> => {
    try {
      const response = await api.post(`${Controllers.CACHE}/clear-key`, { cacheName, key });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  clearAllCaches: async (): Promise<CacheResponse> => {
    try {
      const response = await api.post(`${Controllers.CACHE}/clear-all`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default cacheApi; 